import { loadModal } from '../../AsyncLoader';
import SyosPageComponent from '../SyosPageComponent';

function getBodyContents(seat) {
  return `
    ${SyosPageComponent.removeSeatConfirmationMessage}
    <p>Row: ${seat.row}, Seat: ${seat.number}</p>
  `;
}

const SyosRemoveSeatConfirmationModal = {
  open(syosController, seat) {
    loadModal().then((Modal) => {
      Modal.confirm({
        title: SyosPageComponent.removeSeatConfirmationTitle,
        labelBtnConfirm: SyosPageComponent.removeButton,
        labelBtnCancel: SyosPageComponent.cancelButton,
        onConfirm: seat.removeFromCart.bind(seat),
        bodyContents: getBodyContents(seat),
        root: syosController.$el,
      });
    });
  },
};


export default SyosRemoveSeatConfirmationModal;



// WEBPACK FOOTER //
// ./src/syos/modals/SyosRemoveSeatConfirmationModal.js